import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipProvider,
  TooltipContent,
  TooltipTrigger,
} from "~/atoms/tooltip";
import EasterEggIcon from "~/icons/EasterEggIcon";
import ChickIcon from "~/icons/ChickIcon";

/**
 * Calculate Easter Sunday using the Anonymous Gregorian algorithm.
 * Returns a Date for Easter Sunday in the given year.
 */
function getEasterDate(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month, day);
}

const now = new Date();
const easterSunday = getEasterDate(now.getFullYear());

const diffMs = now.getTime() - easterSunday.getTime();
const diffDays = diffMs / (1000 * 60 * 60 * 24);
const isEasterSeason = diffDays >= -6 && diffDays < 2; // Easter week + the day after easter

export function EasterEgg() {
  const { t } = useTranslation();

  if (!isEasterSeason) {
    return null;
  }

  return (
    <TooltipProvider>
      <div className="flex items-end">
        <Tooltip>
          <TooltipTrigger className="z-10 cursor-help">
            <ChickIcon className="animate-chickWaddle h-10 w-12" />
          </TooltipTrigger>
          <TooltipContent>
            <p>{t("commons.seasonal.easter")}</p>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger className="cursor-help">
            <EasterEggIcon className="animate-eggWobble h-12 w-12" />
          </TooltipTrigger>
          <TooltipContent>
            <p>{t("commons.seasonal.easter")}</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
